import PropTypes from 'prop-types'
import { Form as FormikForm } from 'formik'

const Form = ({ children, ...formProps }) => (
  <FormikForm noValidate {...formProps}>
    {children}
  </FormikForm>
)

Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default Form
